import React from 'react';
import { Spinner } from '@fluentui/react-components';

const FallbackSpinner = () => (
  <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Spinner size="extra-large" />
  </div>
);

export {
  FallbackSpinner
};
